import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import * as moment from 'moment';
import {HttpClient} from '@angular/common/http';
import {version} from '../../../environments/version';
import {Observable} from 'rxjs/Observable';
import {BuildInfo} from '../model/BuildInfo';
import {FormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class UtilService {
  public static imgUrlPrefix = './assets/img/seats/';
  public static carNormal = 'car-seat.svg';
  public static carOrange = 'car-seat-orange.svg';
  public static carGreen = 'car-seat-green.svg';

  constructor(private http: HttpClient) {
  }

  requestsInProgress$ = new BehaviorSubject(0);

  get requestsInProgress() {
    return this.requestsInProgress$.getValue();
  }

  set requestsInProgress(requestsInProgress: number) {
    this.requestsInProgress$.next(requestsInProgress);
  }

  get isDevelopmentMode() {
    return !environment.production;
  }

  getBackendBuildInfo(): Observable<BuildInfo> {
    const url = this.getApiUrl(`public/build/info`);
    return this.http
      .get(url)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return new BuildInfo(response.data);
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          console.error(error);
          return error;
        },
      );
  }

  getVersion() {
    return version;
  }

  getPayWayUrl() {
    return environment.paywayUrl;
  }

  getApiUrl(url: string) {
    return environment.restUrl + environment.restApi + url;
  }

  getPublicUrl(url: string) {
    return environment.restUrl + environment.restPublic + url;
  }

  getLoginData() {
    return environment.login;
  }

  // Moment date
  getSearchDateTimeFrom(dateFrom: any) {
    const currentDateToday = moment();
    dateFrom = moment(dateFrom);

    if (dateFrom.isBefore(currentDateToday)) {
      dateFrom = currentDateToday;
    } else {
      dateFrom.startOf('day');
    }

    return dateFrom.format();
  }

  getSearchDateTimeTo(dateTo: any) {
    dateTo = moment(dateTo);
    dateTo.endOf('day');
    return dateTo.format();
  }

  comparetDate(dateFrom: Date, currentDate: Date) {
    return dateFrom.toDateString() === currentDate.toDateString();
  }

  isOibValid(oib: string) {

    if (oib === null) {
      return false;
    }
    if (oib.length !== 11) {
      return false;
    }

    const b: number = parseInt(oib, 10);
    if (isNaN(b)) {
      return false;
    }

    let a = 10;
    for (let i = 0; i < 10; i++) {
      a = a + parseInt(oib.substr(i, 1), 10);
      a = a % 10;
      if (a === 0) {
        a = 10;
      }
      a *= 2;
      a = a % 11;
    }
    let controlNumber: number = 11 - a;
    if (controlNumber === 10) {
      controlNumber = 0;
    }

    return controlNumber === parseInt(oib.substr(10, 1), 10);
  }

  public static groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/util.service.ts